import { Image as ImageIcon } from 'lucide-react';

const normalizePhotoRecords = (photos) => {
  if (!Array.isArray(photos)) return [];

  return photos
    .map((photo, index) => {
      if (typeof photo === 'string' && photo.trim()) {
        return {
          id: `photo-${index}`,
          url: photo,
        };
      }

      if (photo && typeof photo === 'object' && typeof photo.url === 'string' && photo.url.trim()) {
        return {
          id: photo.id || `photo-${index}`,
          url: photo.url,
        };
      }

      return null;
    })
    .filter(Boolean);
};

const sanitizeForTestId = (value) => String(value || '').replace(/[^a-zA-Z0-9-]/g, '-').toLowerCase();

export const GuestGalleryMasonryGrid = ({
  photos,
  onPhotoClick,
  emptyTitle = 'No photos yet',
  emptySubtitle = 'Photos shared by guests will appear here.',
  testIdPrefix = 'guest-gallery-masonry',
}) => {
  const normalizedPhotos = normalizePhotoRecords(photos);

  if (normalizedPhotos.length === 0) {
    return (
      <div className="rounded-sm border border-stone-200 bg-white p-10 text-center" data-testid={`${testIdPrefix}-empty-state`}>
        <ImageIcon className="mx-auto h-8 w-8 text-stone-400" data-testid={`${testIdPrefix}-empty-icon`} />
        <p className="mt-3 text-stone-800 font-medium" data-testid={`${testIdPrefix}-empty-title`}>{emptyTitle}</p>
        <p className="mt-1 text-sm text-stone-500" data-testid={`${testIdPrefix}-empty-subtitle`}>{emptySubtitle}</p>
      </div>
    );
  }

  return (
    <div className="columns-2 gap-3 sm:columns-3 lg:columns-4" data-testid={`${testIdPrefix}-grid`}>
      {normalizedPhotos.map((photo, index) => {
        const photoId = sanitizeForTestId(photo.id || `${index}`);

        return (
          <article key={`${photo.id}-${index}`} className="mb-3 break-inside-avoid" data-testid={`${testIdPrefix}-item-${photoId}`}>
            <button
              type="button"
              className="group block w-full overflow-hidden rounded-sm border border-stone-200 bg-stone-100 transition hover:border-[#5C0120]/50 focus:outline-none focus:ring-2 focus:ring-[#5C0120]/30"
              onClick={() => onPhotoClick?.(index)}
              data-testid={`${testIdPrefix}-photo-button-${photoId}`}
            >
              <img
                src={photo.url}
                alt={`Guest shared wedding moment ${index + 1}`}
                loading="lazy"
                className="h-auto w-full"
                data-testid={`${testIdPrefix}-photo-image-${photoId}`}
              />
            </button>
          </article>
        );
      })}
    </div>
  );
};
